<template>
  <div class="home container">
    <div v-if="!(isAdmin || isManager)" class="alert alert-success text-center" role="alert">
      <h2>ВАШ БОНУС: <strong>{{userProfile.bonus ? userProfile.bonus : 0}}</strong> руб/кг</h2>
    </div> 
    <Balance v-if="isDeliverer && !isAdmin || !isManager"/>
    <ReportReceiver v-if="isReceiver || isAdmin || isManager"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Balance from '@/views/Balance.vue'
import useCommonMixin from '@/components/commonMixin.js'
//import BalanceReceiver from '@/components/BalanceReceiver.vue'
import ReportReceiver from '@/components/ReportReceiver.vue'

export default {
  components: {
    Balance,
    // BalanceReceiver,
    ReportReceiver,
  },
  setup() {
    useCommonMixin()
    const { isDeliverer, isReceiver, isAdmin, isManager, userProfile } = useCommonMixin()
    
    return {
      isDeliverer,
      userProfile,
      isReceiver,
      isAdmin,
      isManager,
    }
  },
}
</script>
